import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  forwardRef,
  HostBinding,
  InjectionToken,
  Provider,
  QueryList,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { clsx } from 'clsx';

import { RadioBaseGroupDirective } from '../radio-badge-group/radio-base-group.directive';
import { RadioCardComponent } from '../radio-card/radio-card.component';

const CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioCardGroupComponent),
  multi: true,
};

export const SB_RADIO_CARD_GROUP = new InjectionToken<RadioCardGroupComponent>('SbRadioCardGroup');

@Component({
  selector: 'sb-radio-card-group',
  standalone: true,
  imports: [CommonModule],
  exportAs: 'sbRadioCardGroup',
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CONTROL_VALUE_ACCESSOR, { provide: SB_RADIO_CARD_GROUP, useExisting: RadioCardGroupComponent }],
})
export class RadioCardGroupComponent extends RadioBaseGroupDirective {
  @ContentChildren(forwardRef(() => RadioCardComponent), { descendants: true })
  override radios!: QueryList<RadioCardComponent>;

  @HostBinding('class')
  baseClass = clsx('grid auto-cols-fr grid-flow-col gap-2');
}
